import EulaText from "../Components/EulaText";

export default function EULA() {
    return (
        <div style={{display: 'flex', justifyContent: 'center', padding: 24}}>
            <div style={{width: '100%', maxWidth: 900}}>
                <EulaText />
            </div>
        </div>
    )
}